import css from 'styled-jsx/css';

export const InstallmentsStyles = css`
  .installments-text {
    margin: 0px;
    display: flex;
    align-items: center;
    gap: 4px;

    span {
      color: #343e49;
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
      justify-content: center;
      font-family: Lato, sans-serif;
    }
    @media screen and (max-width: 1023px) {
      margin-bottom: 8px;
      margin-top: -10px;
    }
  }
  .cmr-icon {
    background-image: url('/a/fa/product/static/styles/svg/cmr_icon.svg');
    height: 12px;
    width: 19px;
    display: inline-block;
  }
`;
